var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { motionPresets } from './motion/presets';
import { classNames as cn } from './utils';
import { useDesktopLayout } from './useDesktopLayout';
function Popover(_a) {
    var props = __rest(_a, []);
    return _jsx(PopoverPrimitive.Root, Object.assign({ "data-slot": "popover" }, props));
}
function PopoverTrigger(_a) {
    var props = __rest(_a, []);
    return _jsx(PopoverPrimitive.Trigger, Object.assign({ "data-slot": "popover-trigger" }, props));
}
function PopoverContent(_a) {
    var { className, align = 'center', sideOffset = 6, collisionPadding } = _a, props = __rest(_a, ["className", "align", "sideOffset", "collisionPadding"]);
    const isDesktopLayout = useDesktopLayout();
    return (_jsx(PopoverPrimitive.Portal, { children: _jsx(PopoverPrimitive.Content, Object.assign({ "data-slot": "popover-content", align: align, sideOffset: sideOffset, collisionPadding: collisionPadding !== null && collisionPadding !== void 0 ? collisionPadding : (isDesktopLayout ? undefined : 16), className: cn(motionPresets.pop, motionPresets.popover, 'bg-popover text-popover-foreground border-border z-50 max-h-(--radix-popover-content-available-height) w-72 max-w-(--radix-popover-content-available-width) origin-(--radix-popover-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-2xl border shadow-lg outline-hidden lg:max-h-none lg:max-w-none lg:overflow-visible', className) }, props)) }));
}
function PopoverAnchor(_a) {
    var props = __rest(_a, []);
    return _jsx(PopoverPrimitive.Anchor, Object.assign({ "data-slot": "popover-anchor" }, props));
}
/** A note under a list of options, set off by a divider. */
function PopoverFooter(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx("p", Object.assign({ "data-slot": "popover-footer", className: cn('border-base-200 text-text-tertiary mt-1 border-t px-2 pt-2 pb-1 text-xs', className) }, props)));
}
export { Popover, PopoverAnchor, PopoverContent, PopoverFooter, PopoverTrigger, };
